import { render, staticRenderFns } from "./AccountShop.vue?vue&type=template&id=58853c82&scoped=true&"
import script from "./AccountShop.vue?vue&type=script&lang=ts&"
export * from "./AccountShop.vue?vue&type=script&lang=ts&"
import style0 from "./AccountShop.vue?vue&type=style&index=0&id=58853c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58853c82",
  null
  
)

export default component.exports